/** @format */

import React from "react";
import LabelInput from "./labelInput";
import { useFieldStackSpacing } from "./fieldStackContext";

const DriverNameFields = ({
  register,
  errors,
  watch,
  trigger,
  prefix = "",
}) => {
  const isInFieldStack = useFieldStackSpacing();

  return (
    <div className={`tw-grid tw-grid-cols-2 tw-items-start tw-gap-x-2.5 tw-p-0 tw-mb-0 max-[576px]:tw-grid-cols-1 max-[576px]:tw-gap-x-0 ${isInFieldStack ? "max-[576px]:tw-gap-y-4" : "max-[576px]:tw-gap-y-0"}`}>
    <LabelInput
      id={`${prefix}firstName`}
      label="First name"
      type="text"
      placeholder="Enter your first name"
      register={register(`${prefix}firstName`, {
        required: "Required",
      })}
      errors={errors && errors[`${prefix}firstName`]}
      watch={watch(`${prefix}firstName`)}
      trigger={trigger}
      className="max-[576px]:tw-mb-0 max-[576px]:tw-pb-0"
    />
    <LabelInput
      id={`${prefix}lastName`}
      label="Last name"
      type="text"
      placeholder="Enter your last name"
      register={register(`${prefix}lastName`, {
        required: "Required",
      })}
      errors={errors && errors[`${prefix}lastName`]}
      watch={watch(`${prefix}lastName`)}
      trigger={trigger}
      className="max-[576px]:tw-mb-0 max-[576px]:tw-pb-0"
    />
    </div>
  );
};

export default DriverNameFields;
